// Kassenabschluss-/Balancing-Domaene (BON/BONE-Typen POP/PCC/PCR/PCT,
// Zaehlwerte, Einnahmen-Summen) - headless. Extrahiert aus
// CMP_CPosBalancing.js (Plan sharded-hatching-clover, Phase 3.3).
// Fiskalisch relevanter Kern des Tagesabschlusses: Formular-/Dialoglogik
// bleibt im Screen, hier lebt nur Daten-Lesen/-Schreiben.
//
// SQL-Formen zeichengenau vom Original uebernommen (Schema-/Routing-Freeze).

function sql(query) {
  return Promise.resolve(POS.SQLiteCon.execute(query));
}

export const BalancingDomain = {
  // Start-Zeitstempel des letzten Kassa-Oeffnens/-Uebergebens (POP/PCT) -
  // Beginn der aktuellen Kassen-Session.
  getLastPOPTS() {
    return sql("SELECT Start FROM BON WHERE Type IN('POP', 'PCT') AND Cancelled = 0 ORDER BY BON_ID DESC LIMIT 1")
      .then((rows) => (rows.length > 0 && rows[0].Start ? rows[0].Start : 0));
  },

  // Summe einer Sonderzahlungsart (CNT/DLP/PPC/...) seit Session-Beginn.
  getSpecialPayments(mode) {
    return this.getLastPOPTS().then((dbLastPOPTS) =>
      sql("SELECT SUM(BONE.Amount) AS Sum FROM BON INNER JOIN BONE ON BON.BON_ID = BONE.BON_ID " +
        "WHERE BON.End > " + dbLastPOPTS + " AND (BON.Cancelled = 0 OR BON.Cancelled < -1) " +
        "AND BONE.Cancelled = 0 AND BONE.Type = 'PAY' and BONE.Text1 = '" + mode + "'")
        .then((rows) => {
          let sum = 0;
          if (rows.length > 0) {
            sum = parseFloat(rows[0].Sum);
            if (!sum) sum = 0;
          }
          return sum;
        }));
  },

  // Einnahmen seit Session-Beginn: onlyCards=false -> Bar-Einnahmen inkl.
  // Einlagen minus Retouren/Entnahmen; onlyCards=true -> Kartenzahlungen
  // (cardMode 'BK'|'CC'|'all'). PDN-Zeilen (Anzahlungs-Interaction) zaehlen
  // nicht mit.
  async getIncomeSession(onlyCards, cardMode) {
    const dbLastPOPTS = await this.getLastPOPTS();
    let cond;
    if (!onlyCards)
      cond = "(BONE.Type = 'PAY' AND BONE.Text1 NOT IN('BCC', 'CNT', 'PPC', 'DLP', 'PPU') OR BONE.Type IN('MIN', 'MCI'))";
    else {
      switch (cardMode) {
        case "BK": cond = "(BONE.Type = 'PAY' AND BONE.Text1 = 'BCC' AND BONE.Text2 IN('BC', 'DCP'))"; break;
        case "CC": cond = "(BONE.Type = 'PAY' AND BONE.Text1 = 'BCC' AND BONE.Text2 IN('CC', 'CCP'))"; break;
        case "all": cond = "(BONE.Type = 'PAY' AND BONE.Text1 = 'BCC')"; break;
      }
    }

    const rows = await sql("SELECT BONE.Amount, BONE.Interaction FROM BON INNER JOIN BONE ON BON.BON_ID = BONE.BON_ID " +
      "WHERE BON.End > " + dbLastPOPTS + " AND " + cond + " AND BON.Cancelled = 0 " +
      "AND BONE.Cancelled = 0");
    let totalAmountPositive = 0;
    let totalAmountNegative = 0;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].Interaction != "PDN") {
        if (!rows[i].Amount) rows[i].Amount = 0;
        totalAmountPositive += parseFloat(rows[i].Amount);
      }
    }
    if (!onlyCards) {
      const rows2 = await sql("SELECT SUM(BONE.Amount) AS Total FROM BON INNER JOIN BONE ON BON.BON_ID = BONE.BON_ID " +
        "WHERE BON.End > " + dbLastPOPTS + " AND BON.Cancelled = 0 AND BONE.Cancelled = 0 AND " +
        "BONE.Interaction IS NULL AND BONE.Type IN('RET', 'MOU', 'MCO')");
      if (!rows2[0].Total) rows2[0].Total = 0;
      totalAmountNegative += parseFloat(rows2[0].Total);
    }
    return totalAmountPositive - totalAmountNegative;
  },

  // Bar-Summe des letzten Referenz-Bons je Modus (Soll-Stand).
  // mode: 'start' -> letzter PCR, 'transfer'/'out' -> POP, 'end' -> POP/PCT.
  getLastSum(mode) {
    let cond;
    switch (mode) {
      case "start": cond = "Type = 'PCR'"; break;
      case "transfer": cond = "Type = 'POP'"; break;
      case "out": cond = "Type = 'POP'"; break;
      case "end": cond = "Type = 'POP' OR Type = 'PCT'"; break;
    }
    return sql("SELECT MAX(BON_ID) AS MX FROM BON WHERE (" + cond + ") AND POS_ID = " +
      POS.POSId + " AND Cancelled = 0").then((rows) => {
      if (rows.length == 0) return 0;
      return sql("SELECT Amount FROM BONE WHERE BON_ID = " + rows[0].MX + " and Unit = 'BAR'")
        .then((rows2) => {
          let totalAmount = 0;
          for (let i = 0; i < rows2.length; i++) {
            if (!rows2[i].Amount) rows2[i].Amount = 0;
            totalAmount += parseFloat(rows2[i].Amount);
          }
          return totalAmount;
        });
    });
  },

  // Eine Karten-/Sonderzahlungs-Summenzeile am Abschluss-Bon (Type PCC).
  insertBONETransaction(idBon, amount, payMode, date) {
    const quantity = amount > 0 ? 1 : 0;
    return sql("INSERT INTO BONE " +
      "(BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, Reference_BONE_ID, " +
      "TS, Text1, Text2, Unit, Cancelled, ReplacedBy_BONE_ID, " +
      "Interaction) VALUES " + "(" + idBon + ", 'PCC', " +
      quantity + ", " + amount + ", 1, NULL, NULL, " +
      (date / 1000).toFixed(0) + ", NULL, NULL, '" + payMode + "', 0, 0, NULL)");
  },

  // Kompletter Balancing-Bon: BON-Kopf + eine BONE-Zeile pro Zaehlfeld
  // (entries: [{quantity, unitAmount, unit}] in Feld-Reihenfolge), bei PCC
  // zusaetzlich die vier Summenzeilen CRD/CNT/DLP/PPC. Liefert die BON_ID.
  async insertBalancingBon(type, userLogin, userName, cancelled, entries) {
    const d = new Date();
    await sql("INSERT INTO BON " +
      "(Closed, Start, End, POS_ID, U_ID, UName, Cancelled, Type, CUST_ID, Exported) VALUES " +
      "(-1, " + (d / 1000).toFixed(0) + ", 0, " + POS.POSId + ", " +
      userLogin + ", '" + userName + "', " + cancelled + ", '" + type + "', NULL, 0)");
    const row = await sql("SELECT max(BON_ID) as ID from BON where BON.Type='" + type + "'");
    const idBon = row[0].ID;

    for (const e of entries) {
      await sql("INSERT INTO BONE " +
        "(BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, Reference_BONE_ID, " +
        "TS, Text1, Text2, Unit, Cancelled, ReplacedBy_BONE_ID, " +
        "Interaction) VALUES " + "(" + idBon + ", '" + type + "', " +
        e.quantity + ", " + e.amount + ", " + e.unitAmount + ", NULL, NULL, " +
        (d / 1000).toFixed(0) + ", NULL, NULL, '" + e.unit + "', 0, 0, NULL)");
    }

    if (type == "PCC") {
      const amountCards = fix2Decimals(await this.getIncomeSession(true, "all"));
      await this.insertBONETransaction(idBon, amountCards, 'CRD', d);
      const amountCentral = fix2Decimals(await this.getSpecialPayments('CNT'));
      await this.insertBONETransaction(idBon, amountCentral, 'CNT', d);
      const amountDeliveries = fix2Decimals(await this.getSpecialPayments('DLP'));
      await this.insertBONETransaction(idBon, amountDeliveries, 'DLP', d);
      const amountPrepaidCards = fix2Decimals(await this.getSpecialPayments('PPC'));
      await this.insertBONETransaction(idBon, amountPrepaidCards, 'PPC', d);
    }
    // Hinweis: das Original rief getIncomeSession(true,'all') auch fuer
    // Nicht-PCC-Typen auf und verwarf das Ergebnis - dieser wirkungslose
    // Lese-Query entfaellt hier bewusst.
    return idBon;
  },

  // Letzten (beim Anlegen als storniert markierten) PCC-Abschluss freigeben.
  releaseLastPCC() {
    return sql("SELECT MAX(BON_ID) as MX FROM BON where Type = 'PCC'").then((rows) => {
      const maxPCC = rows[0].MX;
      log.add(4, "Info", "Validating balance with id = " + maxPCC, "");
      return sql("UPDATE BON SET Cancelled = 0, Exported = 0 WHERE BON_ID = " + maxPCC);
    });
  },

  // U_ID zu einer Personalnummer (Personalkarten-Scan am Balancing-Screen).
  getUserIdByLogin(loginId) {
    return sql("SELECT U_ID FROM U WHERE Login = '" + loginId + "'");
  },

  // Uebergabe-Ziel-User inkl. PIN-Hash (Kassa-Uebergabe).
  getTransferUser(loginId) {
    return sql("SELECT U_ID, Name, MD5Pass FROM U WHERE Login = " + loginId);
  },

  // Anzahl stornierter Bons seit Session-Beginn (Abschluss-Warnung).
  getCancelledBons() {
    return sql("SELECT Start FROM BON WHERE (Type = 'POP' OR Type = 'PCT') " +
      "ORDER BY BON_ID DESC LIMIT 1").then((rows) => {
      let lastPOPStart = rows[0].Start;
      if (!lastPOPStart) lastPOPStart = 0;
      return sql("SELECT COUNT(*) AS Total FROM BON WHERE End > " + lastPOPStart +
        " AND Cancelled < -1 ORDER BY BON_ID DESC")
        .then((rows2) => (rows2.length > 0 ? rows2[0].Total : 0));
    });
  },

  // Retourwaren-Summe (EXP) seit Session-Beginn.
  getReturnGoodsAmount() {
    return sql("SELECT BON_ID FROM BON WHERE (Type = 'POP' OR Type = 'PCT') " +
      "ORDER BY BON_ID DESC LIMIT 1").then((rows) =>
      sql("SELECT SUM(BONE.Amount) AS Total FROM BONE INNER JOIN BON " +
        "ON BON.BON_ID = BONE.BON_ID WHERE BON.Type = 'EXP' AND BON.Cancelled = 0 " +
        "AND BONE.Type = 'POS' AND BONE.Cancelled = 0 AND BON.BON_ID > " + rows[0].BON_ID)
        .then((rows2) => {
          let amount = rows2.length > 0 ? rows2[0].Total : 0;
          if (!amount) amount = 0;
          return amount;
        }));
  },

  // Reklamations-Summe (REC) seit Session-Beginn.
  getComplainsAmount() {
    return sql("SELECT BON_ID FROM BON WHERE (Type = 'POP' OR Type = 'PCT') " +
      "ORDER BY BON_ID DESC LIMIT 1").then((rows) =>
      sql("SELECT SUM(BONE.Amount) AS Total FROM BONE INNER JOIN BON " +
        "ON BON.BON_ID = BONE.BON_ID WHERE BONE.Type = 'REC' AND BON.Cancelled = 0 " +
        "AND BONE.Cancelled = 0 AND BON.Type = 'CLS' AND BON.BON_ID > " + rows[0].BON_ID)
        .then((rows2) => {
          let amount = rows2.length > 0 ? rows2[0].Total : 0;
          if (!amount) amount = 0;
          return amount;
        }));
  },

  cancelLastChangeOut(bonId) {
    return sql("UPDATE BON SET Cancelled = -1 WHERE BON_ID = " + bonId);
  },
};
